module.exports = __webpack_public_path__ + "static/media/03C.99da9632.png";